module.exports = __webpack_public_path__ + "img/tech-stack-layers.f1843ce9.png";